module.exports = __webpack_public_path__ + "img/icon-arrow-right--skinny.c35ee55c.svg";